import { createEvent, restore } from 'effector';
import { womDevBaseURL } from 'constants/services';

const setWOMBaseURL = createEvent<string>();
const womBaseURL = restore(setWOMBaseURL, womDevBaseURL);

export const globalStores = { womBaseURL };
export const globalEvents = { setWOMBaseURL };
